export default {"src":"/_next/static/media/house.c66a09f9.svg","height":45,"width":51,"blurWidth":0,"blurHeight":0};